import React from 'react';
import { IconProps } from './types';

const StepForwards: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1.15625 * size}
    height={size}
    viewBox="0 0 37 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M1.35 1.4v0c-1.8 1.65-1.8 4.35 0 6.050l8.5 8.6-8.6 8.6c-1.65 1.65-1.65 4.35 0.15 6.050v0c1.65 1.65 4.5 1.65 6.15 0l11.55-11.55c0.9-0.9 1.3-1.95 1.3-3.1s-0.4-2.2-1.3-3.1l-11.55-11.55c-1.8-1.8-4.5-1.8-6.2 0z"
    />
    <path
      fill={!ignoreColor ? color : undefined}
      d="M32.45 32v0c2.45 0 4.35-1.95 4.35-4.35v-23.3c0-2.45-1.95-4.35-4.35-4.35v0c-2.45 0-4.35 1.95-4.35 4.35v23.25c0 2.45 2.050 4.4 4.35 4.4z"
    />
  </svg>
);

export default StepForwards;
